export const heroSlides = [
  {
    eyebrow: "Spring–Summer 2026",
    title: "Sculpted",
    titleItalic: "from earth",
    subtitle:
      "A collection in conversation with regenerative cotton, undyed linen, and the slow hands that shape them.",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20fashion%20photography%20of%20a%20model%20wearing%20flowing%20sculptural%20organic%20cotton%20dress%20in%20warm%20cream%20and%20clay%20tones%2C%20natural%20linen%20textures%2C%20soft%20golden%20afternoon%20sunlight%2C%20minimal%20clean%20studio%20backdrop%20in%20muted%20earth%20bone%20color%2C%20painterly%20fine%20art%20feel%2C%20sustainable%20slow%20fashion%20aesthetic%2C%20artistic%20composition%20with%20negative%20space%2C%20high%20fashion%20couture%20editorial%20mood&width=1600&height=1100&seq=verdant-hero-1&orientation=landscape",
  },
];

// Dedicated hero grid images — high-impact editorial product shots
export const heroFeaturedProducts = [
  {
    id: "h1",
    name: "Architect Trench",
    material: "Regenerative wool · hand-finished",
    price: 620,
    image:
      "https://readdy.ai/api/search-image?query=dramatic%20high-end%20fashion%20editorial%20of%20a%20sculptural%20oversized%20camel%20wool%20trench%20coat%20with%20sharp%20structured%20shoulders%20draped%20on%20minimalist%20stand%2C%20warm%20bone%20cream%20studio%20backdrop%2C%20bold%20directional%20studio%20lighting%20creating%20strong%20shadows%2C%20luxury%20sustainable%20fashion%20product%20photography%2C%20powerful%20silhouette%2C%20clean%20composition%2C%20earth%20tone%20palette%20with%20rich%20depth%2C%20haute%20couture%20visual%20impact&width=900&height=1200&seq=verdant-hero-h1&orientation=portrait",
  },
  {
    id: "h2",
    name: "Drape Silk Gown",
    material: "Peace silk · botanical dye",
    price: 890,
    image:
      "https://readdy.ai/api/search-image?query=striking%20editorial%20fashion%20photography%20of%20a%20flowing%20liquid%20silk%20evening%20gown%20in%20deep%20rust%20terracotta%20color%20with%20dramatic%20fabric%20movement%20suspended%20in%20air%2C%20warm%20neutral%20studio%20background%2C%20strong%20side%20lighting%20highlighting%20sculptural%20folds%2C%20high%20fashion%20couture%20product%20shot%2C%20intense%20visual%20impact%2C%20rich%20earth%20tone%20palette%2C%20artistic%20negative%20space%20composition&width=900&height=1200&seq=verdant-hero-h2&orientation=portrait",
  },
  {
    id: "h3",
    name: "Leather Crossbody",
    material: "Vegetable-tanned leather",
    price: 395,
    image:
      "https://readdy.ai/api/search-image?query=high-impact%20luxury%20fashion%20accessory%20photography%20of%20a%20structured%20minimal%20leather%20crossbody%20bag%20in%20warm%20saddle%20brown%20color%20with%20clean%20geometric%20lines%2C%20suspended%20against%20soft%20cream%20studio%20backdrop%2C%20dramatic%20rim%20lighting%20creating%20bold%20contrast%2C%20sustainable%20artisanal%20leathercraft%20editorial%20shot%2C%20rich%20texture%20detail%2C%20earth%20tone%20palette%2C%20strong%20visual%20presence&width=900&height=1200&seq=verdant-hero-h3&orientation=portrait",
  },
  {
    id: "h4",
    name: "Canvas Field Boot",
    material: "Organic hemp canvas",
    price: 340,
    image:
      "https://readdy.ai/api/search-image?query=powerful%20editorial%20footwear%20photography%20of%20chunky%20sole%20canvas%20boots%20in%20natural%20undyed%20ecru%20color%20with%20raw%20textured%20finish%2C%20photographed%20from%20dramatic%20low%20angle%20on%20warm%20cream%20concrete%20surface%2C%20strong%20directional%20studio%20light%20creating%20bold%20shadows%2C%20sustainable%20fashion%20boot%20product%20shot%2C%20artisanal%20rugged%20aesthetic%2C%20earth%20tone%20palette%2C%20high%20visual%20impact%20composition&width=900&height=1200&seq=verdant-hero-h4&orientation=portrait",
  },
];

export const featuredProducts = [
  {
    id: "p1",
    name: "Atelier Wrap Coat",
    material: "Regenerative wool · undyed",
    price: 480,
    image:
      "https://readdy.ai/api/search-image?query=long%20oversized%20wrap%20coat%20in%20natural%20undyed%20wool%20draped%20on%20minimalist%20mannequin%2C%20warm%20cream%20background%2C%20soft%20diffused%20studio%20light%2C%20sustainable%20fashion%20product%20photography%2C%20sculptural%20silhouette%2C%20clean%20editorial%20composition%2C%20earth%20tone%20palette%2C%20artisanal%20craftsmanship%20feel&width=900&height=1200&seq=verdant-p1&orientation=portrait",
  },
  {
    id: "p2",
    name: "Field Linen Dress",
    material: "European flax linen",
    price: 295,
    image:
      "https://readdy.ai/api/search-image?query=flowing%20long%20linen%20dress%20in%20natural%20beige%20oat%20color%2C%20draped%20on%20studio%20stand%2C%20simple%20warm%20cream%20background%2C%20soft%20natural%20light%20from%20side%2C%20sustainable%20fashion%20editorial%20product%20shot%2C%20minimalist%20composition%2C%20artisanal%20texture%20detail%2C%20serene%20mood&width=900&height=1200&seq=verdant-p2&orientation=portrait",
  },
  {
    id: "p3",
    name: "Stone Knit Sweater",
    material: "Recycled cashmere blend",
    price: 340,
    image:
      "https://readdy.ai/api/search-image?query=chunky%20oversized%20knit%20sweater%20in%20stone%20gray%20wool%2C%20studio%20product%20photography%20on%20warm%20bone%20cream%20backdrop%2C%20soft%20natural%20lighting%2C%20visible%20rich%20knit%20texture%20detail%2C%20sustainable%20slow%20fashion%20brand%20catalog%20shot%2C%20clean%20minimal%20composition&width=900&height=1200&seq=verdant-p3&orientation=portrait",
  },
  {
    id: "p4",
    name: "Clay Wide Trouser",
    material: "Organic hemp cotton",
    price: 245,
    image:
      "https://readdy.ai/api/search-image?query=wide%20leg%20trousers%20in%20warm%20clay%20terracotta%20color%2C%20folded%20and%20styled%20on%20cream%20surface%2C%20sustainable%20fashion%20editorial%20product%20photography%2C%20natural%20studio%20light%2C%20artisanal%20texture%2C%20minimalist%20earth%20tone%20palette%2C%20fine%20art%20composition&width=900&height=1200&seq=verdant-p4&orientation=portrait",
  },
  {
    id: "p5",
    name: "Ember Silk Blouse",
    material: "Peace silk · plant dyed",
    price: 320,
    image:
      "https://readdy.ai/api/search-image?query=soft%20silk%20blouse%20in%20warm%20rust%20terracotta%20color%2C%20draped%20on%20simple%20mannequin%2C%20warm%20cream%20studio%20background%2C%20natural%20soft%20light%2C%20sustainable%20fashion%20product%20shot%2C%20artisanal%20detail%2C%20elegant%20sculptural%20fabric%20fall%2C%20minimalist%20earth%20palette&width=900&height=1200&seq=verdant-p5&orientation=portrait",
  },
];

export const journey = [
  {
    step: "01",
    title: "Soil",
    body: "We partner with five regenerative farms in Portugal and Turkey where cotton and flax restore the land they grow on.",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20raw%20organic%20cotton%20bolls%20and%20linen%20flax%20fibers%20on%20warm%20cream%20linen%20background%2C%20natural%20soft%20light%2C%20artisanal%20detail%20photography%2C%20earth%20tone%20palette%2C%20sustainable%20textile%20raw%20material%20editorial%20shot%2C%20fine%20art%20composition%20with%20negative%20space&width=900&height=1100&seq=verdant-j1&orientation=portrait",
  },
  {
    step: "02",
    title: "Spin",
    body: "Fibers are spun at a family-run mill outside Porto powered entirely by hydroelectric energy from the Douro river.",
    image:
      "https://readdy.ai/api/search-image?query=artisanal%20textile%20mill%20interior%20with%20natural%20yarn%20spools%20in%20cream%20oat%20colors%20stacked%20on%20wooden%20shelves%2C%20warm%20window%20light%2C%20sustainable%20craft%20production%20documentary%20photography%2C%20rich%20texture%20detail%2C%20earthy%20palette%2C%20serene%20industrial%20mood&width=900&height=1100&seq=verdant-j2&orientation=portrait",
  },
  {
    step: "03",
    title: "Dye",
    body: "Botanical pigments from madder root, indigo, and oak gall replace petrochemical dyes. Water leaves cleaner than it arrived.",
    image:
      "https://readdy.ai/api/search-image?query=natural%20botanical%20dye%20process%20with%20fabric%20swatches%20in%20warm%20rust%20clay%20terracotta%20and%20olive%20green%20earth%20tones%20laid%20on%20cream%20linen%20surface%2C%20dried%20plants%20and%20pigment%20powders%2C%20artisanal%20craft%20documentary%20photography%2C%20soft%20natural%20light&width=900&height=1100&seq=verdant-j3&orientation=portrait",
  },
  {
    step: "04",
    title: "Shape",
    body: "Each garment is cut by hand using zero-waste pattern making, then sewn by tailors paid living wages plus profit share.",
    image:
      "https://readdy.ai/api/search-image?query=artisan%20tailor%20hands%20working%20on%20cream%20fabric%20with%20wooden%20pattern%20pieces%20and%20natural%20thread%2C%20warm%20studio%20light%2C%20sustainable%20fashion%20craft%20documentary%20photography%2C%20detailed%20texture%2C%20earth%20tone%20palette%2C%20artisanal%20slow%20production%20feel&width=900&height=1100&seq=verdant-j4&orientation=portrait",
  },
];

export const principles = [
  {
    icon: "ri-plant-line",
    title: "Regenerative First",
    body: "Every fiber begins on a farm that returns more to the soil than it takes.",
  },
  {
    icon: "ri-recycle-line",
    title: "Circular by Design",
    body: "Garments are made to be repaired, resold, and eventually composted.",
  },
  {
    icon: "ri-heart-pulse-line",
    title: "Fair to the Last Hand",
    body: "Every maker in our supply chain earns a living wage and equity in the brand.",
  },
  {
    icon: "ri-leaf-line",
    title: "Carbon Negative",
    body: "We sequester 1.4× the carbon we emit through soil and forest restoration.",
  },
];

export const press = [
  "Vogue",
  "Kinfolk",
  "Cereal",
  "T Magazine",
  "Monocle",
  "AnOther",
];